import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ClipLoader } from 'react-spinners'
import { listActivity } from 'service/AdminPanelService'
import styles from './HistoryViewer.module.scss'

function formatDate(value) {
  if (!value) return ''
  try {
    const d = new Date(value)
    if (Number.isNaN(d.getTime())) return String(value)
    return d.toLocaleString('ru-RU')
  } catch (e) {
    return String(value)
  }
}

function HistoryViewer({
  module,
  targetId,
  targetType,
  q: qProp,
  limit = 50,
  title,
}) {
  const { t } = useTranslation('common')
  const resolvedTitle = title ?? t('components.historyViewer.title')
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)
  const [dateFrom, setDateFrom] = useState('')
  const [dateTo, setDateTo] = useState('')
  const [q, setQ] = useState(qProp || '')

  const load = useCallback(() => {
    setLoading(true)
    const params = { limit }
    if (module) params.module = module
    if (targetId) params.target_object_id = targetId
    if (targetType) params.target_content_type = targetType
    if (dateFrom) params.date_from = dateFrom
    if (dateTo) params.date_to = dateTo
    if (q) params.q = q
    listActivity(params)
      .then((res) => {
        const data = res?.data || res
        const list = Array.isArray(data) ? data : data?.results || []
        setItems(list)
      })
      .catch(() => {
        setItems([])
      })
      .finally(() => setLoading(false))
  }, [module, targetId, targetType, dateFrom, dateTo, q, limit])

  useEffect(() => {
    load()
  }, [load])

  return (
    <div className={styles.wrapper}>
      <h4 className={styles.title}>{resolvedTitle}</h4>

      <div className={styles.toolbar}>
        <input
          type="date"
          className="unv-input"
          value={dateFrom}
          onChange={(e) => setDateFrom(e.target.value)}
          style={{ maxWidth: 160 }}
        />
        <input
          type="date"
          className="unv-input"
          value={dateTo}
          onChange={(e) => setDateTo(e.target.value)}
          style={{ maxWidth: 160 }}
        />
        <input
          type="text"
          className="unv-input"
          placeholder={t('common.search')}
          value={q}
          onChange={(e) => setQ(e.target.value)}
          style={{ maxWidth: 220 }}
        />
        <button type="button" className="unv-btn unv-btn--ghost" onClick={load}>
          {t('common.refresh')}
        </button>
      </div>

      {loading ? (
        <div className={styles.spinner_box}>
          <ClipLoader color="#FF7A00" size={28} />
        </div>
      ) : items.length === 0 ? (
        <div className="unv-empty">{t('components.historyViewer.no_records')}</div>
      ) : (
        <table className="unv-table">
          <thead>
            <tr>
              <th>{t('components.historyViewer.when')}</th>
              <th>{t('components.historyViewer.who')}</th>
              <th>{t('components.historyViewer.action')}</th>
              <th>{t('components.historyViewer.module')}</th>
              <th>{t('components.historyViewer.object')}</th>
            </tr>
          </thead>
          <tbody>
            {items.map((row) => (
              <tr key={row.id || `${row.created_at}-${row.action}`}>
                <td>{formatDate(row.created_at || row.timestamp)}</td>
                <td>{row.actor_username || row.actor || '—'}</td>
                <td>{row.action || '—'}</td>
                <td>{row.module || '—'}</td>
                <td>
                  {row.target_repr || row.target || row.target_object_id || '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}

export default HistoryViewer
